import { useEffect } from 'react';
export function useUserVisibleTabs(apps, tokenHelper) {
    return apps
        .reduce((visibleTabs, app) => {
        var _a;
        if (app.shouldMakeTabVisible || (app.itemKey === 'home-fe' && tokenHelper.isTransactingUser())) {
            for (const tab of (_a = app.tabs) !== null && _a !== void 0 ? _a : []) {
                if (!visibleTabs.includes(tab)) {
                    visibleTabs.push(tab);
                }
            }
        }
        return visibleTabs;
    }, []);
}
export function useWhenClickOutside(ref, fn) {
    useEffect(() => {
        const clickOutsideEventListener = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                fn();
            }
        };
        document.addEventListener('mousedown', clickOutsideEventListener);
        document.addEventListener('touchstart', clickOutsideEventListener);
        return () => {
            document.body.style.overflow = 'unset';
            document.removeEventListener('mousedown', clickOutsideEventListener);
            document.removeEventListener('touchstart', clickOutsideEventListener);
        };
    }, []);
}
